// HTTP status mapping per spec 58 §classifications. Read-only; lint
// enforces that error_code.http_status agrees with the classification.

import type { Classification } from "./types.ts";

const CLASSIFICATION_HTTP_STATUS: Readonly<Record<Classification, number>> =
  Object.freeze({
    validation: 400,
    authentication: 401,
    authorization: 403,
    not_found: 404,
    conflict: 409,
    rate_limited: 429,
    dependency: 502,
    internal: 500,
    unavailable: 503,
  });

const CLASSIFICATION_RETRYABLE: Readonly<Record<Classification, boolean>> =
  Object.freeze({
    validation: false,
    authentication: false,
    authorization: false,
    not_found: false,
    conflict: false,
    rate_limited: true,
    dependency: true,
    internal: false,
    unavailable: true,
  });

export function mapHttpStatus(classification: Classification): number {
  return CLASSIFICATION_HTTP_STATUS[classification];
}

export function isRetryableByDefault(classification: Classification): boolean {
  return CLASSIFICATION_RETRYABLE[classification];
}

export const ALL_CLASSIFICATIONS: readonly Classification[] = Object.freeze([
  "validation",
  "authentication",
  "authorization",
  "not_found",
  "conflict",
  "rate_limited",
  "dependency",
  "internal",
  "unavailable",
] as const);
